module.exports = __webpack_public_path__ + "static/media/Floatzel_gaussian2.cf97795c.png";